import React from 'react';
import leftLogo from "../../../assets/images/logos/LmsLogo1.png";
import { firstLetterShouldCapital } from "../../../../utils/utils";

const QrPrintContent = React.forwardRef(({ printData }, ref) => {
  const {
    printPatientInfo,
    qrCodeDataUrl,
    bagCount = 0,
    printCount = 1,
    printSingleBag,
    patientMedicalInfo = {},
  } = printData || {};

  const patientInfo = printPatientInfo?.patient_information || {};
  const patientName = patientInfo.name || "";

  return (
    <div ref={ref} className="font-sans">
      {Array.from({ length: printCount }).map((_, index) => (
        <div
          key={index}
          style={{
            width: "14.25cm",
            height: "10.25cm",
            border: "1px solid #000",
            boxSizing: "border-box",
            pageBreakAfter: "always",
            padding: "0.6cm",
            fontSize: "10px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Top strip with small logo + header */}
          <div className="flex items-start justify-between mb-2">
            <div className="flex items-center gap-2">
              <div className="text-right flex items-end gap-1 text-lg">
                <img src={leftLogo} width={20} height={20} alt='imunoact360-logo' />
                <span className='text-sm'>ImmunoACT</span>
              </div>
            </div>
            <div className="flex-1 text-center">
              <div className="text-lg font-bold tracking-wide">
                Leukapheresis Starting Material
              </div>
              <div className="text-[0.7rem] mt-0.5">
                For Manufacturing of Autologous CAR-T Products
              </div>
            </div>
            {/* Right side left empty or for any icon you may add later */}
            <div style={{ width: 30, height: 30 }} />
          </div>

          {/* Body: patient info + QR code */}
          <div className="flex justify-between items-start gap-4">
            {/* Left: patient details */}
            <div className="text-[0.8rem] leading-relaxed space-y-1">
              <p>
                <span className="font-bold">Patient Name: </span>
                <span className="font-semibold">{patientInfo.name}</span>
              </p>
              <p>
                <span className="font-bold">Patient Initials: </span>
                <span className="font-semibold">
                  {firstLetterShouldCapital(patientName)}
                </span>
              </p>
              <p>
                <span className="font-bold">Patient body weight: </span>
                <span className="font-semibold">
                  {patientInfo.body_weight} Kg
                </span>
              </p>
              <p>
                <span className="font-bold">Disease Indication: </span>
                <span className="font-semibold">{patientInfo.disease}</span>
              </p>
              <p>
                <span className="font-bold">Date of Birth: </span>
                <span className="font-semibold">
                  {patientMedicalInfo["Date of Birth"]}
                </span>
              </p>
              <p>
                <span className="font-bold">Hospital name: </span>
                <span className="font-semibold">{patientInfo.hospital}</span>
              </p>
              <p>
                <span className="font-bold">Hospital Patient ID: </span>
                <span className="font-semibold">{patientInfo.patient_id}</span>
              </p>
              <p>
                <span className="font-bold">ImmunoACT Patient ID: </span>
                <span className="font-semibold">
                  {patientInfo.immunoact_patient_id}
                </span>
              </p>
              <p>
                <span className="font-bold">
                  Ship and Store at{" "}
                  {patientMedicalInfo["Ship & Store"]}
                </span>
              </p>
              <p>
                <span className="font-bold">Bag no: </span>
                <span className="font-semibold inline-block min-w-[80px] border-b border-black">
                  {printSingleBag ? printSingleBag : bagCount + index + 1}
                </span>
              </p>
            </div>

            {/* Right: QR code */}
            <div className="w-[90px] h-[90px] flex-shrink-0 flex items-start justify-end">
              {qrCodeDataUrl && (
                <img
                  src={qrCodeDataUrl}
                  alt="QR Code"
                  className="w-full h-full object-contain"
                />
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
});

export default QrPrintContent;
